import { useAangifte } from "components/aangifte/AangifteProvider";
import React, { MouseEventHandler, FunctionComponent } from "react";
import "./navigationButton.css";

export interface Props {
  icon: string;
  title: string;
  active: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const PersonalTaxFormNavigationButton: FunctionComponent<Props> = ({ title, active, icon, onClick }) => {
  const {
    aangifte: { city },
  } = useAangifte();
  return (
    <div className="process-step">
      <button
        className={`btn ${active ? "btn-info" : "btn-default"} btn-circle`}
        onClick={onClick}
        type="button"
        disabled={!city}
      >
        <i className={`fa fa-${icon} fa-2x`} title={title}></i>
      </button>
      <p>
        <small>{title}</small>
      </p>
    </div>
  );
};

PersonalTaxFormNavigationButton.displayName = "PersonalTaxFormNavigationButton";
